import * as React from 'react';
import { doFileDownload } from '../../store/upload';
import { Button } from 'primereact/button';

export default function DocumentLink({ fileName, fileId }: { fileName: string, fileId: string }) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  async function doDownload() {
      setIsLoading(true);
  
      try {
        const res = await doFileDownload({
          fileId: fileId!,
          fileName: fileName!,
        });
    
        if (res && res.link) {
          const downloadLink = document.createElement('a');
          downloadLink.href = res.link;
          downloadLink.download = fileName;
          downloadLink.target = '_blank';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.remove();    
        }
      } finally {      
        setIsLoading(false);
      }
  }


  return (
    <Button
      size="small"
      rounded
      onClick={doDownload}
      severity="secondary"
      loading={isLoading}
    >
      <span className="flex items-center gap-1 text-allstate-navy">
          <span className="pi pi-file"></span>
          <span>{fileName}</span>
        </span> 
    </Button>
  )
}